import * as React from 'react';
import Main from './Main';
import '../fonts/fonts.css';

interface Props {

}

/* App is the root component.*/
class App extends React.Component {

    constructor(props: Props) {
        super(props);
    }

  render() {
    return (
          <Main/>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/opt/atlassian/pipelines/agent/build/src/common/ui/App.tsx